<!-- Edit Question Type Overlay -->
<p-overlayPanel #change_question_type_overlay>
  <!-- Form -->
  @if (questionTypeForm) {
    <medsurf-design-form-control-form
      [formGroup]="questionTypeForm"
      (onSubmit)="onQuestionTypeSubmit()">
      <!-- Type -->
      <medsurf-design-form-control-input-dropdown [control]="questionTypeForm.controls.type"
        [label]="'global.question_type'"
        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
        [options]="FlatModels.QuestionEntityModels.QuestionTypeArray"
        (valueChange)="$event.originalEvent.stopPropagation()"></medsurf-design-form-control-input-dropdown>
      <div class="flex flex-row column-gap-2">
        <!-- Back -->
        <button medsurf-design-input-button [id]="'question_type_edit_cancel'"
          [label]="'global.cancel' | translate"
        (click)="change_question_type_overlay.hide()"></button>
        <!-- Submit -->
        <medsurf-design-form-control-input-submit [formField]="false"
                                                  [label]="'global.save_changes'"
                                                  [disabled]="questionTypeForm.invalid || isSubmitted()"></medsurf-design-form-control-input-submit>
      </div>
    </medsurf-design-form-control-form>
  }
</p-overlayPanel>

<!-- Question -->
<ng-template #question_template
  let-index="index"
  let-question="question"
  let-currentQuestion="currentQuestion">
  <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
    <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer h-3rem"
      [class.bg-white-alpha-10]="(slideAuthorFacade.currentSelectedSlideQuestion$ | async) === question"
      (click)="onQuestionExpand(question.id, currentQuestion?.id)">
      <div class="flex w-2rem">
        <button medsurf-design-input-button [id]="'question_handle_' +  question.id"
          [title]="'global.question_handle' | translate"
          [class]="'handle cursor-move'"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED_WHITE"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
      </div>
      <div class="flex w-2rem">
        <button medsurf-design-input-button [id]="'question_toggle'"
          [title]="(currentQuestion?.id !== question.id ? 'global.question_toggle_open' : 'global.question_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
        [iconClass]="(currentQuestion?.id !== question.id ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"></button>
      </div>
      <div class="flex w-auto">
        <medsurf-design-content-chip [tooltipLabel]="'global.question_type' | translate">
          {{ 'enum.question.' + question.type | translate }}
        </medsurf-design-content-chip>
      </div>
      <div class="flex flex-grow-1 p-2 w-0">
        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
          [innerHTML]="question.content | stripTags">
        </span>
      </div>
      <div [hidden]="currentQuestion?.id !== question.id"
        class="flex flex-shrink-0 flex-row flex-nowrap column-gap-2 justify-content-end mr-2">
        <button medsurf-design-input-button [id]="'question_remove_' + question.id"
          [title]="'global.question_remove' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_SMALL"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
        (click)="removeQuestion(question)"></button>
        <button medsurf-design-input-button [id]="'question_edit_type_' + question.id"
          [title]="'global.question_edit_type' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SHUFFLE"
        (click)="onQuestionTypeEdit($event, question)"></button>
      </div>
    </div>
    <div [hidden]="currentQuestion?.id !== question.id"
      class="flex flex-column row-gap-1 p-2 surface-700 mb-2">
      @switch (question.type) {
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.MappingQuestion) {
          <medsurf-quiz-mapping-question
            [index]="index"
          [question]="question"></medsurf-quiz-mapping-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.LongListQuestion) {
          <medsurf-quiz-single-choice-question
            [index]="index"
          [question]="question"></medsurf-quiz-single-choice-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.SingleChoiceQuestion) {
          <medsurf-quiz-single-choice-question
            [index]="index"
          [question]="question"></medsurf-quiz-single-choice-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.TrueFalseQuestion) {
          <medsurf-quiz-k-prim-question
            [index]="index"
          [question]="question"></medsurf-quiz-k-prim-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.KprimeQuestion) {
          <medsurf-quiz-k-prim-question
            [index]="index"
          [question]="question"></medsurf-quiz-k-prim-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.FreeTextQuestion) {
          <medsurf-quiz-freetext-question
            [index]="index"
          [question]="question"></medsurf-quiz-freetext-question>
        }
        @case (FlatModels.QuestionEntityModels.QuestionType.enum.IndicationQuestion) {
          <medsurf-quiz-indication-question
            [index]="index"
          [question]="question"></medsurf-quiz-indication-question>
        }
      }
    </div>
  </div>
</ng-template>

<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlidePage$ | async; as page) {
  @if (slideAuthorFacade.currentSelectedSlideQuestions$ | async | sortBy_shared:'asc':'order'; as questions) {
    <div class="w-full">
      <div class="flex flex-column row-gap-1"
        [dragula]="getDragulaKey('questions')"
        [dragulaModel]="questions"
        (dragulaModelChange)="onQuestionMoved(page, $event)">
        @if (questions.length === 0) {
          <span class="m-2">
            {{ 'global.no_questions' | translate }}
          </span>
        }
        @if ({
          currentQuestion: slideAuthorFacade.currentSelectedSlideQuestion$ | async
        }; as questionData) {
          @for (question of questions; track trackBy(index, question); let index = $index) {
          <ng-container *ngTemplateOutlet="question_template,context:{
                        index: index,
                        question: question,
                        currentQuestion: questionData.currentQuestion}">
            </ng-container>
          }
        }
      </div>
    </div>
  }
}
